import { FC, MouseEvent } from "react";
import { useSelector } from "react-redux";

import { Button, Icon } from "../../common";
import { PDFInvoice } from "../../../components/savePDF";
import { useGetInvoiceDetails } from "../../../hooks/useGetInvoiceDetails";
import { selectCurrentUser } from "../../../store/reducers/user";
import { Invoice } from "../../../types/InvoiceTypes";
import { generatePdfDocument } from "../../../utils/actions/generatePdfDocument";
import { track } from "../../../utils/tracking";

// Send either `invoice` or `invoiceId` to PDF generation. If `invoiceId` is
// provided, invoice details are requested from the backend.
type Props = {
  invoice?: Invoice;
  invoiceId?: string;
  label?: boolean;
  className?: string;
};

export const DownloadInvoiceAction: FC<Props> = ({
  invoice,
  invoiceId = "",
  label,
  className,
}) => {
  const currentUser = useSelector(selectCurrentUser);
  const invoiceDetails = useGetInvoiceDetails(invoiceId);

  if (!invoiceId && !invoice) {
    return <></>;
  }

  const data = invoiceDetails || invoice;

  const downloadHandler = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (data) {
      track("invoice_downloaded", {
        invoice_id: data.id,
        viewer_id: currentUser?.id,
      });

      generatePdfDocument(<PDFInvoice data={data} />, `Invoice-${data.number}`);
    }
  };

  const variant = label ? Button.variant.TERTIARY : Button.variant.SECONDARY;

  return (
    <Button
      contentClassName={className}
      icon={!label}
      onClick={downloadHandler}
      variant={variant}
    >
      {label && <>Download PDF</>}
      <Icon icon="Download" size={24} className="text-gray-500" disableFill />
    </Button>
  );
};
